<template>
  <div id="repairRecordDetail" class="business-content-main">
    <div class="bread-nav">
      <div>您当前位置：</div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客服</el-breadcrumb-item>
        <el-breadcrumb-item>检修管理</el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- <el-button @click="goback" type="primary" size="mini" style="position:absolute;right:37px">返回</el-button> -->
    </div>
    <div class="order-details-main">
      <div class="order-status">
        <div class="order-status1">
          <div>订单号：{{RepairRecordModel.OrderCode}}</div>
          <div class="status-text">{{RepairRecordModel.StateName}}</div>
          <div class="print">
            <i class="fa fa-print"></i>打印订单
          </div>
        </div>
        <div class="order-status2">
          <div class="order-dur">订单状态</div>
          <el-steps :active="StepsIndex" align-center>
            <el-step
              v-for="item in RepairRecordModel.Steps"
              :key="item.State"
              :title="item.State"
              :description="item.TriggerTime"
            ></el-step>
          </el-steps>
        </div>
      </div>
      <el-card class="box-card">
        <div>
          <div class="table-ctn">
            <!--待审核状态，存在没有关联的配件,并且未开始询价的展现此按钮-->
            <el-button
              type="primary"
              size="small"
              v-if="createBtn&&RepairRecordModel.OrderState==3&&!RepairRecordModel.IsAllGoodsAssociated&&RepairRecordModel.InquiryState==0"
              @click="createHandler"
            >创建询价单</el-button>
            <el-button type="primary" size="small" v-if="sureBtn" @click="sureHandler">确定</el-button>
            <el-button type="info" size="small" v-if="cancelBtn" @click="cancelHandler">取消创建</el-button>
            <el-tag type="danger" v-if="RepairRecordModel.InquiryState==1">询价中</el-tag>
            <el-tag type="danger" v-if="RepairRecordModel.InquiryState==2">询价完成</el-tag>
            <el-table :data="RepairRecordModel.Goods" ref="GoodsTable" style="width: 100%">
              <el-table-column
                type="selection"
                width="55"
                v-if="sureBtn"
                :selectable="checkselectable"
              ></el-table-column>
              <el-table-column width="390" label="商品">
                <template slot-scope="scope">
                  <div class="shop-msg">
                    <img
                      :src="downloadUrl+scope.row.GoodsImg"
                      alt=""
                      class="shop-cover"
                      :onerror="defaultImg"
                    >
                    <p style="margin-left: 10px">{{scope.row.GoodsName}}</p>
                  <el-tag type="danger" size='mini' style="margin-left: 10px" v-if="scope.row.InquiryState>0">询价商品</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="GoodsCode" label="商品编号">
                <template slot-scope="scope">
                  <el-select
                    v-if="!scope.row.IsAssociated&&scope.row.Type==0&&scope.row.InquiryState<2"
                    v-model="scope.row.CodeSel"
                    value-key="GoodsId"
                    filterable
                    remote
                    :remote-method="getAutoPartsList"
                    :loading="selectloading"
                    @change="autoPartsChange($event,scope.row)"
                    clearable
                    size="mini"
                    placeholder="请输入配件名"
                  >
                    <template>
                      <div class="optionHeader">
                        <span style="margin-left:0;">编号</span>
                        <span>名称</span>
                        <span>车型</span>
                        <span>历史最高价</span>
                      </div>
                    </template>
                    <el-option
                      v-for="item in autoPartsList"
                      :key="item.GoodsId"
                      :label="item.GoodsCode"
                      :value="item"
                    >
                      <span style="margin-left:0px;">{{ item.GoodsCode }}</span>
                      <span>{{ item.GoodsName }}</span>
                      <span>{{ item.AutoSerieName }}</span>
                      <span>{{ item.HistoryMaxPrice }}</span>
                    </el-option>
                  </el-select>
                  <span v-else>{{ scope.row.GoodsCode }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="ActualCount" label="商品数量"></el-table-column>
              <el-table-column prop="InstallationFee" label="安装费用"></el-table-column>
              <el-table-column prop="ShopPrice" label="配件价格(元)">
                <template slot-scope="{row, $index}">
                  <el-input
                    class="input-number"
                    type="number"
                    v-model="row.ShopPrice"
                    controls-position="right"
                    @input="handleInput($event, $index, 'ShopPrice')"
                    @change="handleChange(row)"
                    :min="0"
                    size="mini"
                    v-if="row.Type==0&&RepairRecordModel.OrderState==3&&!RepairRecordModel.IsCancel"
                  ></el-input>
                  <span v-else>{{ row.ShopPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="Discount" label="优惠金额(元)">
                <template slot-scope="{row, $index}">
                  <el-input
                    class="input-number"
                    type="number"
                    v-model="row.Discount"
                    controls-position="right"
                    @input="handleInput($event, $index, 'Discount')"
                    @change="handleChange(row)"
                    :min="0"
                    size="mini"
                    v-if="row.Type==0&&RepairRecordModel.OrderState==3&&!RepairRecordModel.IsCancel"
                  ></el-input>
                  <span v-else>{{row.Discount}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="display: flex;justify-content: space-between;">
            <div class="client-msg">
              <div>
                <div class="client-item">
                  <span class="key">汽修厂：</span>
                  <span class="value">{{RepairRecordModel.EntpName}}</span>
                </div>
                <div class="client-item">
                  <span class="key">车主：</span>
                  <span class="value">{{RepairRecordModel.ClientName}}</span>
                </div>
                <div class="client-item">
                  <span class="key">手机号：</span>
                  <span class="value">{{RepairRecordModel.ClientPhone}}</span>
                </div>
              </div>
              <div style="margin-left:50px;">
                <div class="client-item">
                  <span class="key">车牌：</span>
                  <span class="value">{{RepairRecordModel.CarNum}}</span>
                </div>
                <div class="client-item">
                  <span class="key">车型：</span>
                  <span class="value">{{RepairRecordModel.AutoSeries}}</span>
                </div>
              </div>
            </div>
            <div class="money-msg">
              <div>
                <div class="money-item">
                  <span class="key">商品总额：</span>
                  <span class="value">￥{{RepairRecordModel.OrderAmount | numToFixed}}</span>
                </div>
                <div class="money-item">
                  <span class="key">优&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;惠：</span>
                  <span class="value">￥{{RepairRecordModel.DiscountsMoney | numToFixed}}</span>
                </div>
                <div class="money-item all-money">
                  <span class="key">应付总额：</span>
                  <span class="value font-md">￥{{RepairRecordModel.PaymentAmount | numToFixed}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <div class="ops-ctn">
      <template v-if="RepairRecordModel.OrderState==3&&!RepairRecordModel.IsCancel">
        <el-button type="primary" size="small" @click="submitReview">提交并推送</el-button>
        <el-button size="small" @click="goback">取消</el-button>
      </template>
      <template v-else>
        <el-button size="small" type="primary" @click="goback">返回</el-button>
      </template>
    </div>
    <el-dialog
      title="创建询价单"
      size="medium"
      width="70%"
      :visible.sync="IBDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="controlIBDialogVisible({visible:false})"
    >
      <!--用作注销元素-->
      <div v-if="IBDialogVisible">
        <inquiryBillObject
          ref="inquiryBillObject"
          :objects="selectedApData"
          :repairOrderId="RepairRecordModel.OrderId"
          :entpId="RepairRecordModel.EntpId"
          @controlIBDialogVisible="controlIBDialogVisible"
        ></inquiryBillObject>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import inquiryBillObject from "@/components/business/inquire/inquiryBillObject.vue";
export default {
  name: "repairRecordDetail",
  components: {
    inquiryBillObject
  },
  data() {
    return {
      OrderId: "",
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
      downloadUrl: this.$util.QN_URL_BASE,
      StepsIndex: 0,
      RepairRecordModel: {},
      autoPartsList: [],
      selectloading: false,
      createBtn: true,
      sureBtn: false,
      cancelBtn: false,
      IBDialogVisible: false,
      selectedApData: [],
      Unit: ["件", "个", "片", "只", "台", "升", "毫升"]
    };
  },
  mounted() {
    this.orderId = this.$route.query.OrderId;
    this.GetRepairRecord();
  },
  filters: {
    numToFixed(val) {
      if (!isNaN(val)) {
        return val.toFixed(2)
      } else {
        return 0
      }
    }
  },
  methods: {
    goback() {
      this.$router.push("/business/repairManagement/repairRecords");
    },
    GetRepairRecord() {
      this.axios
        .get("/RepairManagement/GetRepairRecord", {
          params: { OrderId: this.orderId }
        })
        .then(result => {
          this.RepairRecordModel = result.data.data;
          let Steps = result.data.data.Steps;

          for (let i = 0; i < Steps.length; i++) {
            if (Steps[i].IsCurrStep) {
              if (i == Steps.length - 1) {
                this.StepsIndex = Steps.length;
              } else {
                this.StepsIndex = i;
              }
              break;
            }
          }

          let goods = this.RepairRecordModel.Goods;
          this.tableData = goods.map(i => {
            this.$set(i, "CodeSel", "");
            return i;
          });
        });
    },
    //获取汽配件列表，其实这里是获取报价记录历史的数据
    getAutoPartsList(searchKey) {
      if (!searchKey) {
        return;
      }
      this.selectloading = true;
      let asid = this.RepairRecordModel.AutoSerieId;
      this.axios
        .get("/ERPGood/GetHistoryGoodsList", {
          params: { autoSeriesId: asid, search: searchKey },
          data: {}
        })
        .then(response => {
          let data = response.data.data;
          if (data && data.length > 0) {
            this.autoPartsList = data;
          } else {
            this.autoPartsList = [];
          }
        });
      this.selectloading = false;
    },
    //选中汽配
    autoPartsChange(sel, row) {
      if (sel == null) {
        row.GoodsId = "";
        row.GoodsName = "";
        row.GoodsCode = "";
        row.ShopPrice = "";
        row.GoodsImg = "";
      } else {
        row.GoodsId = sel.GoodsId;
        row.GoodsName = sel.GoodsName;
        row.GoodsCode = sel.GoodsCode;
        row.ShopPrice = sel.HistoryMaxPrice;
        if (sel.MainImg) {
          row.GoodsImg = sel.MainImg;
        }
      }
      this.handleChange(row);
    },
    //金额改变
    handleChange(row) {
      if (
        (row.ShopPrice + row.InstallationFee) * row.ActualCount <
        row.Discount
      ) {
        this.$util.warningMsg("优惠金额不得大于配件价格！");
        // setTimeout(() => {
        //   row.Discount = 0;
        // }, 0);
        // return;
      }
      setTimeout(() => {
        let price = 0;
        let discount = 0;
        for (const item of this.RepairRecordModel.Goods) {
          price += (item.ShopPrice ? item.ShopPrice * 1 : 0) * item.ActualCount + item.InstallationFee  * 1;
          discount += item.Discount ? item.Discount * 1 : 0;
        }
        this.RepairRecordModel.OrderAmount = price * 1;
        this.RepairRecordModel.DiscountsMoney = discount * 1;
        this.RepairRecordModel.PaymentAmount =
          price - discount > 0 ? (price - discount) * 1 : 0;
      }, 0);
    },
    handleInput(e, index, value) {
      if (e && !/^\d+\.?\d{0,2}$/.test(e)) {
        let sptArr = e.split('.')
        this.RepairRecordModel.Goods[index][value] = `${sptArr[0]}.${sptArr[1].substr(0, 2)}` * 1
      }
    },
    //提交审核
    submitReview() {
      let that = this;
      let GoodsList = [];
      for (const item of this.RepairRecordModel.Goods) {
        if (!item.GoodsId) {
          this.$util.warningMsg("关联的商品信息不完整，请补全数据再提交！");
          return false;
        }
        if (item.ShopPrice == 0 || !item.ShopPrice) {
          this.$util.warningMsg("请填写配件价格！");
          return false;
        }
        if (
          item.ShopPrice * item.ActualCount + item.InstallationFee <
          item.Discount
        ) {
          this.$util.warningMsg("优惠金额不得大于配件价格！");
          return false;
        }

        GoodsList.push({
          RsId: item.RsId,
          GoodsId: item.GoodsId,
          ShopPrice: item.ShopPrice,
          Discount: item.Discount
        });
      }
      //如果维修单存在询价单正在询价中
      if (this.RepairRecordModel.InquiryState==1) {
        this.openTip(
          "维修单存在询价单，如果提交数据会作废询价单，是否继续？",
          function() {
            that.submitData(GoodsList);
          }
        );
      } else {
        this.submitData(GoodsList);
      }
    },

    //保存数据
    submitData(GoodsList) {
      let _formData = {
        OrderId: this.orderId,
        InInquiry: this.RepairRecordModel.InInquiry,
        GoodsList: GoodsList
      };
      this.axios
        .post("/RepairManagement/FillPrice", _formData)
        .then(res => {
          if (res.data.errcode == 0) {
            this.$util.successMsg("提交成功");
            setTimeout(() => {
              this.$router.push(`/business/repairManagement/repairRecords`);
            }, 0);
          } else {
            this.$message.error("提交失败！");
          }
        })
        .catch(() => {
          this.$message.error("提交失败！");
        });
    },

    openTip(msg, callback) {
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          callback && callback();
        })
        .catch(() => {});
    },
    //创建询价单
    createHandler() {
      this.createBtn = false;
      this.sureBtn = true;
      this.cancelBtn = true;
    },
    //判断是否可以选择
    checkselectable(row) {
      if (row.Type == 0) {
        return true;
      } else {
        return false;
      }
    },
    //打开创建询价单窗口
    sureHandler() {
      let _selectData = this.$refs.GoodsTable.selection;
      if (_selectData.length == 0) {
        this.$util.warningMsg("请选中要询价的商品！");
        return;
      }
      this.selectedApData = _selectData;
      this.controlIBDialogVisible({ visible: true });
    },
    //取消
    cancelHandler() {
      this.createBtn = true;
      this.sureBtn = false;
      this.cancelBtn = false;
      this.$refs.GoodsTable.clearSelection();
    },

    //控制询价单弹窗是否展现 {visible, action}
    controlIBDialogVisible(data) {
      this.IBDialogVisible = data.visible;
      if (data.action == "create") {
        //保存询价后
        this.cancelHandler();
        this.RepairRecordModel.InInquiry = true; //询价中
        this.RepairRecordModel.InquiryState=1;
      }
    }
  }
};
</script>

<style>
.business-content-main .box-card .input-number {
  width: 130px;
}
</style>

<style lang="less" scoped>
// .bread-nav {
//   justify-content: space-between;
// }
.order-status {
  display: flex;
  background: @border4Color;
  padding: 20px;
  margin-bottom: 20px;
}

.order-status1 {
  width: 20%;
  border-right: 1px solid @border3Color;
  text-align: center;
  div {
    margin-bottom: 20px;
  }
}
.status-text {
  font-size: @font-lg;
  color: @theme2;
  font-weight: bold;
}

.order-status2 {
  width: 80%;
  padding-left: 20px;
}
.order-dur {
  padding-bottom: 20px;
}
.shop-msg {
  display: flex;
  align-items: center;
}
.shop-cover {
  width: 80px;
  height: 80px;
}
.money-msg {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}
.money-item {
  // width: 175px;
  display: flex;
  justify-content: space-between;
  line-height: 2em;
  font-size: @font-sm;
}
.all-money {
  color: red;
}
.back {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: @font-md;
  color: @theme;
  i {
    font-size: 24px;
    margin-right: 10px;
  }
}
.ops-ctn {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: 150px;
  z-index: 1;
}
.client-msg {
  display: flex;
  justify-content: flex-start;
  // position: absolute;
  // left: 0;
  padding-top: 20px;
}
.client-item {
  // width: 175px;
  width: auto;
  display: flex;
  // justify-content: space-between;
  line-height: 2em;
  font-size: @font-sm;
}
.optionHeader {
  height: 34px;
  padding: 0 20px;
  line-height: 34px;
  color: #303133;
  font-weight: bold;
}
.optionHeader span {
  float: left;
  margin-left: 20px;
  min-width: 150px;
}
.el-select-dropdown__list li > span {
  float: left;
  margin-left: 20px;
  min-width: 150px;
}
</style>
